module.exports = __webpack_public_path__ + "static/4-7011e30979197b9fa7d17d41b0a81fcf.jpg";